export const fieldsTypeUnit = [
  {
    typeId: 3, fields: [
      { name: 'useful_area', show: true, required: true },
      { name: 'total_area', show: true, required: true },
      { name: 'manufacturing_area', show: false, required: false },
      { name: 'carpet_area', show: false, required: false },
      { name: 'patio_area', show: false, required: false },
      { name: 'right_foot', show: false, required: false },
      { name: 'bedroom', show: true, required: true },
      { name: 'suite', show: true, required: true },
      { name: 'bathroom', show: true, required: true },
      { name: 'car_spaces', show: true, required: true },
      { name: 'living_room', show: true, required: true },
      { name: 'kitchen_pantry', show: false, required: false },
      { name: 'kitchen', show: false, required: false },
      { name: 'docks', show: false, required: false },
      { name: 'mezzanine', show: false, required: false },
      { name: 'number_floors', show: false, required: false }
    ]
  },
  {
    typeId: 28, fields: [
      { name: 'useful_area', show: true, required: true },
      { name: 'total_area', show: true, required: true },
      { name: 'manufacturing_area', show: false, required: false },
      { name: 'carpet_area', show: false, required: false },
      { name: 'patio_area', show: false, required: false },
      { name: 'right_foot', show: false, required: false },
      { name: 'bedroom', show: true, required: true },
      { name: 'suite', show: true, required: true },
      { name: 'bathroom', show: true, required: true },
      { name: 'car_spaces', show: true, required: true },
      { name: 'living_room', show: true, required: true },
      { name: 'kitchen_pantry', show: false, required: false },
      { name: 'kitchen', show: false, required: false },
      { name: 'docks', show: false, required: false },
      { name: 'mezzanine', show: false, required: false },
      { name: 'number_floors', show: false, required: false }
    ]
  },
  {
    typeId: 30, fields: [
      { name: 'useful_area', show: true, required: true },
      { name: 'total_area', show: true, required: true },
      { name: 'manufacturing_area', show: false, required: false },
      { name: 'carpet_area', show: false, required: false },
      { name: 'patio_area', show: false, required: false },
      { name: 'right_foot', show: false, required: false },
      { name: 'bedroom', show: true, required: true },
      { name: 'suite', show: true, required: true },
      { name: 'bathroom', show: true, required: true },
      { name: 'car_spaces', show: true, required: true },
      { name: 'living_room', show: true, required: true },
      { name: 'kitchen_pantry', show: false, required: false },
      { name: 'kitchen', show: false, required: false },
      { name: 'docks', show: false, required: false },
      { name: 'mezzanine', show: false, required: false },
      { name: 'number_floors', show: false, required: false }
    ]
  },
  {
    typeId: 31, fields: [
      { name: 'useful_area', show: true, required: true },
      { name: 'total_area', show: true, required: true },
      { name: 'manufacturing_area', show: false, required: false },
      { name: 'carpet_area', show: false, required: false },
      { name: 'patio_area', show: false, required: false },
      { name: 'right_foot', show: false, required: false },
      { name: 'bedroom', show: true, required: true },
      { name: 'suite', show: true, required: true },
      { name: 'bathroom', show: true, required: true },
      { name: 'car_spaces', show: true, required: true },
      { name: 'living_room', show: true, required: true },
      { name: 'kitchen_pantry', show: false, required: false },
      { name: 'kitchen', show: false, required: false },
      { name: 'docks', show: false, required: false },
      { name: 'mezzanine', show: false, required: false },
      { name: 'number_floors', show: false, required: false }
    ]
  },
  {
    typeId: 32, fields: [
      { name: 'useful_area', show: true, required: true },
      { name: 'total_area', show: true, required: true },
      { name: 'manufacturing_area', show: false, required: false },
      { name: 'carpet_area', show: false, required: false },
      { name: 'patio_area', show: false, required: false },
      { name: 'right_foot', show: false, required: false },
      { name: 'bedroom', show: true, required: true },
      { name: 'suite', show: true, required: true },
      { name: 'bathroom', show: true, required: true },
      { name: 'car_spaces', show: true, required: true },
      { name: 'living_room', show: true, required: true },
      { name: 'kitchen_pantry', show: false, required: false },
      { name: 'kitchen', show: false, required: false },
      { name: 'docks', show: false, required: false },
      { name: 'mezzanine', show: false, required: false },
      { name: 'number_floors', show: false, required: false }
    ]
  },
  {
    typeId: 21, fields: [
      { name: 'useful_area', show: true, required: true },
      { name: 'total_area', show: true, required: true },
      { name: 'manufacturing_area', show: false, required: false },
      { name: 'carpet_area', show: false, required: false },
      { name: 'patio_area', show: false, required: false },
      { name: 'right_foot', show: false, required: false },
      { name: 'bedroom', show: true, required: true },
      { name: 'suite', show: true, required: true },
      { name: 'bathroom', show: true, required: true },
      { name: 'car_spaces', show: true, required: true },
      { name: 'living_room', show: true, required: true },
      { name: 'kitchen_pantry', show: false, required: false },
      { name: 'kitchen', show: false, required: false },
      { name: 'docks', show: false, required: false },
      { name: 'mezzanine', show: false, required: false },
      { name: 'number_floors', show: false, required: false }
    ]
  },
  {
    typeId: 34, fields: [
      { name: 'useful_area', show: true, required: true },
      { name: 'total_area', show: true, required: true },
      { name: 'manufacturing_area', show: false, required: false },
      { name: 'carpet_area', show: false, required: false },
      { name: 'patio_area', show: false, required: false },
      { name: 'right_foot', show: false, required: false },
      { name: 'bedroom', show: true, required: true },
      { name: 'suite', show: true, required: true },
      { name: 'bathroom', show: true, required: true },
      { name: 'car_spaces', show: true, required: true },
      { name: 'living_room', show: true, required: true },
      { name: 'kitchen_pantry', show: false, required: false },
      { name: 'kitchen', show: false, required: false },
      { name: 'docks', show: false, required: false },
      { name: 'mezzanine', show: false, required: false },
      { name: 'number_floors', show: false, required: false }
    ]
  },
  {
    typeId: 2, fields: [
      { name: 'useful_area', show: true, required: true },
      { name: 'total_area', show: true, required: true },
      { name: 'manufacturing_area', show: false, required: false },
      { name: 'carpet_area', show: false, required: false },
      { name: 'patio_area', show: false, required: false },
      { name: 'right_foot', show: false, required: false },
      { name: 'bedroom', show: true, required: true },
      { name: 'suite', show: true, required: true },
      { name: 'bathroom', show: true, required: true },
      { name: 'car_spaces', show: true, required: true },
      { name: 'living_room', show: true, required: true },
      { name: 'kitchen_pantry', show: false, required: false },
      { name: 'kitchen', show: false, required: false },
      { name: 'docks', show: false, required: false },
      { name: 'mezzanine', show: false, required: false },
      { name: 'number_floors', show: false, required: false }
    ]
  },
  {
    typeId: 26, fields: [
      { name: 'useful_area', show: true, required: true },
      { name: 'total_area', show: true, required: true },
      { name: 'manufacturing_area', show: false, required: false },
      { name: 'carpet_area', show: false, required: false },
      { name: 'patio_area', show: false, required: false },
      { name: 'right_foot', show: false, required: false },
      { name: 'bedroom', show: true, required: true },
      { name: 'suite', show: true, required: true },
      { name: 'bathroom', show: true, required: true },
      { name: 'car_spaces', show: true, required: true },
      { name: 'living_room', show: true, required: true },
      { name: 'kitchen_pantry', show: false, required: false },
      { name: 'kitchen', show: false, required: false },
      { name: 'docks', show: false, required: false },
      { name: 'mezzanine', show: false, required: false },
      { name: 'number_floors', show: false, required: false }
    ]
  },
  {
    typeId: 27, fields: [
      { name: 'useful_area', show: true, required: true },
      { name: 'total_area', show: true, required: true },
      { name: 'manufacturing_area', show: false, required: false },
      { name: 'carpet_area', show: false, required: false },
      { name: 'patio_area', show: false, required: false },
      { name: 'right_foot', show: false, required: false },
      { name: 'bedroom', show: true, required: true },
      { name: 'suite', show: true, required: true },
      { name: 'bathroom', show: true, required: true },
      { name: 'car_spaces', show: true, required: true },
      { name: 'living_room', show: true, required: true },
      { name: 'kitchen_pantry', show: false, required: false },
      { name: 'kitchen', show: false, required: false },
      { name: 'docks', show: false, required: false },
      { name: 'mezzanine', show: false, required: false },
      { name: 'number_floors', show: false, required: false }
    ]
  },
  {
    typeId: 29, fields: [
      { name: 'useful_area', show: true, required: true },
      { name: 'total_area', show: true, required: true },
      { name: 'manufacturing_area', show: false, required: false },
      { name: 'carpet_area', show: false, required: false },
      { name: 'patio_area', show: false, required: false },
      { name: 'right_foot', show: false, required: false },
      { name: 'bedroom', show: true, required: true },
      { name: 'suite', show: true, required: true },
      { name: 'bathroom', show: true, required: true },
      { name: 'car_spaces', show: true, required: true },
      { name: 'living_room', show: true, required: true },
      { name: 'kitchen_pantry', show: false, required: false },
      { name: 'kitchen', show: false, required: false },
      { name: 'docks', show: false, required: false },
      { name: 'mezzanine', show: false, required: false },
      { name: 'number_floors', show: false, required: false }
    ]
  },
  {
    typeId: 33, fields: [
      { name: 'useful_area', show: true, required: true },
      { name: 'total_area', show: true, required: true },
      { name: 'manufacturing_area', show: false, required: false },
      { name: 'carpet_area', show: false, required: false },
      { name: 'patio_area', show: false, required: false },
      { name: 'right_foot', show: false, required: false },
      { name: 'bedroom', show: true, required: true },
      { name: 'suite', show: true, required: true },
      { name: 'bathroom', show: true, required: true },
      { name: 'car_spaces', show: true, required: true },
      { name: 'living_room', show: true, required: true },
      { name: 'kitchen_pantry', show: false, required: false },
      { name: 'kitchen', show: false, required: false },
      { name: 'docks', show: false, required: false },
      { name: 'mezzanine', show: false, required: false },
      { name: 'number_floors', show: false, required: false }
    ]
  },
  {
    typeId: 35, fields: [
      { name: 'useful_area', show: true, required: true },
      { name: 'total_area', show: true, required: true },
      { name: 'manufacturing_area', show: false, required: false },
      { name: 'carpet_area', show: false, required: false },
      { name: 'patio_area', show: false, required: false },
      { name: 'right_foot', show: false, required: false },
      { name: 'bedroom', show: true, required: true },
      { name: 'suite', show: true, required: true },
      { name: 'bathroom', show: true, required: true },
      { name: 'car_spaces', show: true, required: true },
      { name: 'living_room', show: true, required: true },
      { name: 'kitchen_pantry', show: false, required: false },
      { name: 'kitchen', show: false, required: false },
      { name: 'docks', show: false, required: false },
      { name: 'mezzanine', show: false, required: false },
      { name: 'number_floors', show: false, required: false }
    ]
  },
  {
    typeId: 17, fields: [
      { name: 'useful_area', show: true, required: true },
      { name: 'total_area', show: true, required: true },
      { name: 'manufacturing_area', show: false, required: false },
      { name: 'carpet_area', show: false, required: false },
      { name: 'patio_area', show: false, required: false },
      { name: 'right_foot', show: false, required: false },
      { name: 'bedroom', show: true, required: true },
      { name: 'suite', show: true, required: true },
      { name: 'bathroom', show: true, required: true },
      { name: 'car_spaces', show: true, required: true },
      { name: 'living_room', show: true, required: true },
      { name: 'kitchen_pantry', show: false, required: false },
      { name: 'kitchen', show: false, required: false },
      { name: 'docks', show: false, required: false },
      { name: 'mezzanine', show: false, required: false },
      { name: 'number_floors', show: false, required: false }
    ]
  },
  {
    typeId: 36, fields: [
      { name: 'useful_area', show: true, required: true },
      { name: 'total_area', show: true, required: true },
      { name: 'manufacturing_area', show: true, required: true },
      { name: 'carpet_area', show: true, required: true },
      { name: 'patio_area', show: true, required: true },
      { name: 'right_foot', show: true, required: true },
      { name: 'bedroom', show: false, required: false },
      { name: 'suite', show: false, required: false },
      { name: 'bathroom', show: true, required: true },
      { name: 'car_spaces', show: true, required: true },
      { name: 'living_room', show: true, required: true },
      { name: 'kitchen_pantry', show: false, required: false },
      { name: 'kitchen', show: false, required: false },
      { name: 'docks', show: true, required: true },
      { name: 'mezzanine', show: true, required: true },
      { name: 'number_floors', show: false, required: false }
    ]
  },
  {
    typeId: 8, fields: [
      { name: 'useful_area', show: true, required: true },
      { name: 'total_area', show: true, required: true },
      { name: 'manufacturing_area', show: false, required: false },
      { name: 'carpet_area', show: false, required: false },
      { name: 'patio_area', show: false, required: false },
      { name: 'right_foot', show: false, required: false },
      { name: 'bedroom', show: true, required: true },
      { name: 'suite', show: true, required: true },
      { name: 'bathroom', show: true, required: true },
      { name: 'car_spaces', show: true, required: true },
      { name: 'living_room', show: true, required: true },
      { name: 'kitchen_pantry', show: true, required: true },
      { name: 'kitchen', show: true, required: true },
      { name: 'docks', show: true, required: true },
      { name: 'mezzanine', show: true, required: true },
      { name: 'number_floors', show: true, required: true }
    ]
  },
  {
    typeId: 7, fields: [
      { name: 'useful_area', show: true, required: true },
      { name: 'total_area', show: true, required: true },
      { name: 'manufacturing_area', show: false, required: false },
      { name: 'carpet_area', show: false, required: false },
      { name: 'patio_area', show: false, required: false },
      { name: 'right_foot', show: false, required: false },
      { name: 'bedroom', show: true, required: true },
      { name: 'suite', show: true, required: true },
      { name: 'bathroom', show: true, required: true },
      { name: 'car_spaces', show: true, required: true },
      { name: 'living_room', show: true, required: true },
      { name: 'kitchen_pantry', show: false, required: false },
      { name: 'kitchen', show: false, required: false },
      { name: 'docks', show: false, required: false },
      { name: 'mezzanine', show: false, required: false },
      { name: 'number_floors', show: false, required: false }
    ]
  },
  {
    typeId: 19, fields: [
      { name: 'useful_area', show: true, required: true },
      { name: 'total_area', show: true, required: true },
      { name: 'manufacturing_area', show: false, required: false },
      { name: 'carpet_area', show: false, required: false },
      { name: 'patio_area', show: false, required: false },
      { name: 'right_foot', show: false, required: false },
      { name: 'bedroom', show: false, required: false },
      { name: 'suite', show: false, required: false },
      { name: 'bathroom', show: false, required: false },
      { name: 'car_spaces', show: true, required: true },
      { name: 'living_room', show: false, required: false },
      { name: 'kitchen_pantry', show: true, required: true },
      { name: 'kitchen', show: true, required: true },
      { name: 'docks', show: false, required: false },
      { name: 'mezzanine', show: true, required: true },
      { name: 'number_floors', show: false, required: false }
    ]
  },
  {
    typeId: 5, fields: [
      { name: 'useful_area', show: true, required: true },
      { name: 'total_area', show: true, required: true },
      { name: 'manufacturing_area', show: false, required: false },
      { name: 'carpet_area', show: false, required: false },
      { name: 'patio_area', show: false, required: false },
      { name: 'right_foot', show: false, required: false },
      { name: 'bedroom', show: true, required: true },
      { name: 'suite', show: true, required: true },
      { name: 'bathroom', show: true, required: true },
      { name: 'car_spaces', show: true, required: true },
      { name: 'living_room', show: true, required: true },
      { name: 'kitchen_pantry', show: false, required: false },
      { name: 'kitchen', show: false, required: false },
      { name: 'docks', show: false, required: false },
      { name: 'mezzanine', show: false, required: false },
      { name: 'number_floors', show: false, required: false }
    ]
  },
  {
    typeId: 38, fields: [
      { name: 'useful_area', show: true, required: true },
      { name: 'total_area', show: true, required: true },
      { name: 'manufacturing_area', show: false, required: false },
      { name: 'carpet_area', show: false, required: false },
      { name: 'patio_area', show: false, required: false },
      { name: 'right_foot', show: false, required: false },
      { name: 'bedroom', show: false, required: false },
      { name: 'suite', show: false, required: false },
      { name: 'bathroom', show: true, required: true },
      { name: 'car_spaces', show: true, required: true },
      { name: 'living_room', show: false, required: false },
      { name: 'kitchen_pantry', show: false, required: false },
      { name: 'kitchen', show: false, required: false },
      { name: 'docks', show: false, required: false },
      { name: 'mezzanine', show: false, required: false },
      { name: 'number_floors', show: false, required: false }
    ]
  },
  {
    typeId: 40, fields: [
      { name: 'useful_area', show: true, required: true },
      { name: 'total_area', show: true, required: true },
      { name: 'manufacturing_area', show: false, required: false },
      { name: 'carpet_area', show: false, required: false },
      { name: 'patio_area', show: false, required: false },
      { name: 'right_foot', show: false, required: false },
      { name: 'bedroom', show: false, required: false },
      { name: 'suite', show: false, required: false },
      { name: 'bathroom', show: false, required: false },
      { name: 'car_spaces', show: false, required: false },
      { name: 'living_room', show: false, required: false },
      { name: 'kitchen_pantry', show: false, required: false },
      { name: 'kitchen', show: false, required: false },
      { name: 'docks', show: false, required: false },
      { name: 'mezzanine', show: false, required: false },
      { name: 'number_floors', show: false, required: false }
    ]
  },
  {
    typeId: 41, fields: [
      { name: 'useful_area', show: true, required: true },
      { name: 'total_area', show: true, required: true },
      { name: 'manufacturing_area', show: false, required: false },
      { name: 'carpet_area', show: false, required: false },
      { name: 'patio_area', show: false, required: false },
      { name: 'right_foot', show: false, required: false },
      { name: 'bedroom', show: true, required: true },
      { name: 'suite', show: true, required: true },
      { name: 'bathroom', show: true, required: true },
      { name: 'car_spaces', show: true, required: true },
      { name: 'living_room', show: true, required: true },
      { name: 'kitchen_pantry', show: false, required: false },
      { name: 'kitchen', show: false, required: false },
      { name: 'docks', show: false, required: false },
      { name: 'mezzanine', show: false, required: false },
      { name: 'number_floors', show: false, required: false }
    ]
  },
  {
    typeId: 42, fields: [
      { name: 'useful_area', show: true, required: true },
      { name: 'total_area', show: true, required: true },
      { name: 'manufacturing_area', show: false, required: false },
      { name: 'carpet_area', show: false, required: false },
      { name: 'patio_area', show: false, required: false },
      { name: 'right_foot', show: false, required: false },
      { name: 'bedroom', show: true, required: true },
      { name: 'suite', show: true, required: true },
      { name: 'bathroom', show: true, required: true },
      { name: 'car_spaces', show: true, required: true },
      { name: 'living_room', show: true, required: true },
      { name: 'kitchen_pantry', show: false, required: false },
      { name: 'kitchen', show: false, required: false },
      { name: 'docks', show: false, required: false },
      { name: 'mezzanine', show: false, required: false },
      { name: 'number_floors', show: false, required: false }
    ]
  },
  {
    typeId: 44, fields: [
      { name: 'useful_area', show: true, required: true },
      { name: 'total_area', show: true, required: true },
      { name: 'manufacturing_area', show: false, required: false },
      { name: 'carpet_area', show: false, required: false },
      { name: 'patio_area', show: false, required: false },
      { name: 'right_foot', show: false, required: false },
      { name: 'bedroom', show: true, required: true },
      { name: 'suite', show: true, required: true },
      { name: 'bathroom', show: true, required: true },
      { name: 'car_spaces', show: true, required: true },
      { name: 'living_room', show: true, required: true },
      { name: 'kitchen_pantry', show: true, required: true },
      { name: 'kitchen', show: true, required: true },
      { name: 'docks', show: true, required: true },
      { name: 'mezzanine', show: true, required: true },
      { name: 'number_floors', show: true, required: true }
    ]
  },
  {
    typeId: 39, fields: [
      { name: 'useful_area', show: true, required: true },
      { name: 'total_area', show: true, required: true },
      { name: 'manufacturing_area', show: false, required: false },
      { name: 'carpet_area', show: false, required: false },
      { name: 'patio_area', show: false, required: false },
      { name: 'right_foot', show: false, required: false },
      { name: 'bedroom', show: false, required: false },
      { name: 'suite', show: false, required: false },
      { name: 'bathroom', show: true, required: true },
      { name: 'car_spaces', show: true, required: true },
      { name: 'living_room', show: true, required: true },
      { name: 'kitchen_pantry', show: false, required: false },
      { name: 'kitchen', show: false, required: false },
      { name: 'docks', show: false, required: false },
      { name: 'mezzanine', show: false, required: false },
      { name: 'number_floors', show: false, required: false }
    ]
  },
  {
    typeId: 4, fields: [
      { name: 'useful_area', show: true, required: true },
      { name: 'total_area', show: true, required: true },
      { name: 'manufacturing_area', show: false, required: false },
      { name: 'carpet_area', show: false, required: false },
      { name: 'patio_area', show: false, required: false },
      { name: 'right_foot', show: false, required: false },
      { name: 'bedroom', show: false, required: false },
      { name: 'suite', show: false, required: false },
      { name: 'bathroom', show: true, required: true },
      { name: 'car_spaces', show: true, required: true },
      { name: 'living_room', show: true, required: true },
      { name: 'kitchen_pantry', show: true, required: true },
      { name: 'kitchen', show: true, required: true },
      { name: 'docks', show: false, required: false },
      { name: 'mezzanine', show: true, required: true },
      { name: 'number_floors', show: false, required: false }
    ]
  },
  {
    typeId: 43, fields: [
      { name: 'useful_area', show: true, required: true },
      { name: 'total_area', show: true, required: true },
      { name: 'manufacturing_area', show: false, required: false },
      { name: 'carpet_area', show: false, required: false },
      { name: 'patio_area', show: false, required: false },
      { name: 'right_foot', show: false, required: false },
      { name: 'bedroom', show: true, required: true },
      { name: 'suite', show: true, required: true },
      { name: 'bathroom', show: true, required: true },
      { name: 'car_spaces', show: true, required: true },
      { name: 'living_room', show: true, required: true },
      { name: 'kitchen_pantry', show: false, required: false },
      { name: 'kitchen', show: false, required: false },
      { name: 'docks', show: false, required: false },
      { name: 'mezzanine', show: false, required: false },
      { name: 'number_floors', show: false, required: false }
    ]
  },
  {
    typeId: 23, fields: [
      { name: 'useful_area', show: true, required: true },
      { name: 'total_area', show: true, required: true },
      { name: 'manufacturing_area', show: false, required: false },
      { name: 'carpet_area', show: false, required: false },
      { name: 'patio_area', show: false, required: false },
      { name: 'right_foot', show: false, required: false },
      { name: 'bedroom', show: true, required: true },
      { name: 'suite', show: true, required: true },
      { name: 'bathroom', show: true, required: true },
      { name: 'car_spaces', show: true, required: true },
      { name: 'living_room', show: true, required: true },
      { name: 'kitchen_pantry', show: false, required: false },
      { name: 'kitchen', show: false, required: false },
      { name: 'docks', show: false, required: false },
      { name: 'mezzanine', show: false, required: false },
      { name: 'number_floors', show: false, required: false }
    ]
  },
];
